import React from 'react'
import {Switch, Route} from 'react-router-dom'
import ReservationCalendar from '../ReservationCalendar'
import ReservationGantt from '../ReservationGantt'
import ReservationBookings from '../ReservationBookings'
import ReservationNewCalendar from '../ReservationNewCalendar'

const Routes = () => {
  return (
    <Switch>
      <Route path="/reservations/calendar" component={ReservationNewCalendar} />
      <Route path="/reservations/new_calendar" component={ReservationNewCalendar} />
      <Route path="/reservations/gantt" component={ReservationGantt} />
      <Route path="/reservations/bookings" component={ReservationBookings} />
    </Switch>
  )
}

export default Routes
